var defaultLocale = 'en-US';
export var Locale = {
  defaultLocale: defaultLocale,
  browserLocale: function browserLocale(nav) {
    var documentLanguage = window.document.documentElement.lang;
    if (documentLanguage) return documentLanguage;
    var hasNavigatorLanguages = window.navigator && window.navigator.languages && window.navigator.languages.length;
    if (hasNavigatorLanguages) return window.navigator.languages[0];
    var hasNavigatorLanguage = window.navigator && window.navigator.language;
    if (hasNavigatorLanguage) return window.navigator.language;
    return defaultLocale;
  }
};
export default Locale;